"use client"

import { useRef } from "react"
import { useCursorContext } from "../components/CursorProvider"

interface UseCursorOptions {
  variant: string
  onEnter?: () => void
  onLeave?: () => void
}

export const useCursor = ({ variant, onEnter, onLeave }: UseCursorOptions) => {
  const { setCursorVariant } = useCursorContext()
  // Prevent double-push when both mouseenter and focus fire on the same interaction
  // (e.g. clicking a button fires mouseenter → push, then focus → push again;
  //  mouseleave only pops once, leaving a dangling stack entry).
  const isActiveRef = useRef(false)

  return {
    onMouseEnter() {
      if (!isActiveRef.current) { isActiveRef.current = true; setCursorVariant(variant, "push") }
      onEnter?.()
    },
    onMouseLeave() {
      if (isActiveRef.current) { isActiveRef.current = false; setCursorVariant("", "pop") }
      onLeave?.()
    },
    onFocus() {
      if (!isActiveRef.current) { isActiveRef.current = true; setCursorVariant(variant, "push") }
      onEnter?.()
    },
    onBlur() {
      if (isActiveRef.current) { isActiveRef.current = false; setCursorVariant("", "pop") }
      onLeave?.()
    },
    "data-cursor-target": true,
  }
}
